export async function validatePhoneNumber(phoneNumber: string) {
  const libPhone = await import('libphonenumber-js');
  const result = libPhone.parsePhoneNumberFromString(phoneNumber, {
    defaultCountry: 'CH',
  });
  return result;
}
